export enum CandidateScoreRating {
    Hottest = 1,
    Hotter = 2,
    Hot = 3,
    Marketing = 4
}
